import { apiClient } from '../../app/api';

export interface StoredObject {
  id: number;
  tenantId: number | null;
  objectKey: string;
  publicUrl: string;
  contentType: string;
  sizeBytes: number;
}

export function uploadAdminFile(file: File): Promise<StoredObject> {
  const form = new FormData();
  form.append('file', file);
  return apiClient.post<StoredObject>('/admin/uploads', form);
}
